import React, { useState } from 'react'
import { Container, Form, Tabs, Tab, Button, Row, Col } from 'react-bootstrap'
import { ORDERS_COLLECTION, serverTimestamp } from '../../firebase'
import { v4 as uuidv4 } from 'uuid';
import { useHistory } from 'react-router';

const INITIAL_STATE = {
    _id: '',
    contact: '',
    date: serverTimestamp.now(),
    done: false,
    game: '',
    method_of_payment: '',
    name: '',
    price: ''
}

const AddOrder = () => {

    const history = useHistory();

    const [add, setAdd] = useState(INITIAL_STATE)

    const handleAdd = async (e) => {

        e.preventDefault();

        const _id = uuidv4();

        await ORDERS_COLLECTION.doc(_id).set({
            _id: _id,
            contact: add.contact,
            date: add.date,
            done: 'true' === add.done,
            game: add.game,
            method_of_payment: add.method_of_payment,
            name: add.name,
            price: add.price
        })
            .then(() => {
                alert("Uspješno dodano 👍")
                history.push('/preview-order')
            })
            .catch((error) => {
                alert(error.message)
            })
    }

    return (
        <>
            <div>
                <Container>
                    <Tabs defaultActiveKey="add-order" className="mb-3" transition={false}>
                        <Tab eventKey="preview-order" title={<div onClick={() => history.push('/preview-order')}>Pregled narudžbi</div>} />
                        <Tab eventKey="add-order" title="Dodaj">
                            <Form onSubmit={handleAdd}>
                                <Row>
                                    <Col lg={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Kontakt</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Unesite - Kontakt"
                                                value={add.contact}
                                                onChange={(e) => { setAdd({ ...add, contact: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Završeno</Form.Label>
                                            <Form.Control
                                                as="select"
                                                value={add.done}
                                                onChange={(e) => { setAdd({ ...add, done: e.target.value }) }}
                                                required
                                            >
                                                <option value="" disabled>Odaberite</option>
                                                <option value="false">Ne</option>
                                                <option value="true">Da</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Igra</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Unesite - Igra"
                                                value={add.game}
                                                onChange={(e) => { setAdd({ ...add, game: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Način plaćanja</Form.Label>
                                            <Form.Control
                                                as="select"
                                                value={add.method_of_payment}
                                                onChange={(e) => { setAdd({ ...add, method_of_payment: e.target.value }) }}
                                                required
                                            >
                                                <option value="" disabled>Odaberite</option>
                                                <option value="Uplatnica (banka ili pošta)">Uplatnica (banka ili pošta)</option>
                                                <option value="Paypal (+5% provizija)">Paypal (+5% provizija)</option>
                                                <option value="Xbon (+5% provizija)">Xbon (+5% provizija)</option>
                                                <option value="Kriptovalute (stablecoins)">Kriptovalute (stablecoins)</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Ime</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Unesite - Ime"
                                                value={add.name}
                                                onChange={(e) => { setAdd({ ...add, name: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Cijena</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Unesite - Cijena"
                                                value={add.price}
                                                onChange={(e) => { setAdd({ ...add, price: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <Button variant="primary" type="submit">
                                            Dodaj
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Tab>
                        <Tab eventKey="edit-order" title='Uredi' disabled />
                        <Tab eventKey="delete-order" title='Obriši' disabled />
                    </Tabs>
                </Container>
            </div>
        </>
    )
}

export default AddOrder
